export default __webpack_public_path__ + "media/images/video-overlay-f8c1e332a076e7db9627ccf71d5bca32.png";